function NotFound() {
    return <h2>Pagina non trovata!</h2>;
}

export default NotFound;